<template>
  <div>
    <div class="banner">
      <div class="word" v-if="false">
        <span class="title">
          合作伙伴
        </span>
        <span class="subtitle">
          十年间，极客邦科技已经服务超过25000家中国和全球企业，服务的行业包括了互联网、金融、银行、证券、制造、快消、零售、汽车、医疗、教育等领域。
        </span>
      </div>
    </div>
    <com-prodserv :data="prodservs"></com-prodserv>
    <com-message :messages="messages"></com-message>
    <com-partner :partners="partners"></com-partner>
  </div>
</template>
<script>
import comPartner from '@/components/com-partner'
import comProdserv from '@/view/partner/com-prodserv'
import comMessage from '@/view/partner/com-message'
export default {
  data () {
    return {
      partners: []
    }
  },
  components: {
    comMessage,
    comPartner,
    comProdserv
  },
  created () {
    this.getPartners()
  },
  methods: {
    getPartners () {
      this.$ajax.get('https://events.geekbang.org/serv/partner/index')
        .then((res) => {
          if (Array.isArray(res.data)) {
            res.data.forEach(el => {
              if (el.avatar.indexOf('7xil0e.com1.z0.glb.clouddn.com') > -1) {
                el.avatar = el.avatar.replace('7xil0e.com1.z0.glb.clouddn.com', '7xil0e.com2.z0.glb.clouddn.com')
              }
            })
          }
          this.partners = res.data
        })
        .catch((err) => {
          alert(err)
        })
    }
  },
  computed: {
    prodservs () {
      return [{
        img: 'https://static.geekbang.org/infoq/5a71597a3b072.png?imageView2/0/',
        word: '极客时间 App',
        link: 'https://time.geekbang.org/'
      }, {
        img: 'https://static.geekbang.org/infoq/5ab075ee23602.png?imageView2/0/',
        word: 'CTO 圈子',
        link: 'https://TGO.geekbang.org/'
      }, {
        img: 'https://static.geekbang.org/infoq/5ab075ee7dfae.png?imageView2/0/',
        word: '技术会议',
        link: 'https://www.geekbang.org/'
      }, {
        img: 'https://static.geekbang.org/infoq/5ab075edbedf0.png?imageView2/0/',
        word: '媒体资讯',
        link: 'http://www.infoq.com/cn'
      }, {
        img: 'https://static001-test.geekbang.org/resource/image/92/90/92593a1480fc5bdd62a0dbd5f6c2f590.png',
        word: '极客时间企业版',
        link: 'https://service.geekbang.org/'
      }]
    },
    messages () {
      return [{
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7abd68bab77.png?imageView2/0/',
        word: '对于一个有价值的事情，能坚持十年，这种凝聚力和专注力就令人尊重。极客邦科技一直致力于给技术人和产品人提供优质的服务，助力成长。这个使命在这个大科技时代具有更广阔的意义，十年磨一剑。祝极客邦科技下一个十年发展更精彩。',
        company: '腾讯联合创始人',
        author: '张志东（tony）'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a279a29aa322.png?imageView2/0/',
        word: '极是科技，客是年轻人，邦是公益精神，极客邦科技把服务好技术年轻人变成了事业和理想，令人敬佩，祝极客邦科技再上一个阶梯，更期待下一个令人向往的十年。',
        company: '云栖小镇名誉镇长、阿里巴巴技术委员会主席',
        author: '王坚'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7bc1b26a25d.png?imageView2/0/',
        word: '从百度云开始，我们就与极客邦科技开展全方位的合作。2017年，百度的 Apollo 平台又在第一时间选择极客邦科技成为 Apollo 社区建设的首批合作伙伴，这体现出我们对极客邦科技专业能力和服务精神的认可！在此我代表百度 Apollo 运营团队，祝我们的合作越来越深入，共同服务于行业开发者，培育更多的技术人才！',
        company: '百度 Apollo 运营总经理',
        author: '张辉'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7942fee58ba.png?imageView2/0/',
        word: '不忘初心，知识驱动价值；牢记使命，服务释放能量。',
        company: '微软 CMO',
        author: 'Diana'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7942ff2879b.png?imageView2/0/w/800',
        word: '取前沿信息上还是市场活动中都助益匪浅。极客邦科技上线的 IT 类知识产品”极客时间“App，帮助用户遴选最优质的 IT 知识内容，我们相信以极客邦科技的专业与严谨一定能在知识服务领域取得更辉煌的成就。在这个高速发展的时代，我代表懒投资团队祝愿极客邦科技在专业领域能稳步发展，希望懒投资与极客邦科技能够进行更深入的合作，共同成长进步，在各自领域为用户带来更专业的产品与服务。',
        company: '懒投资 总裁',
        author: '陈裕殷'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7942ff5e8b1.png?imageView2/0/',
        word: '极客邦科技见证了明略从大数据成功转型人工智能企业。技术一直是明略的核心竞争力，2015年起，明略就与极客邦科技开展技术及品牌传播层面合作；极客邦科技以前瞻的技术洞察和良好的媒体口碑，为明略提升技术品牌形象；我们也十分感谢霍泰稳先生一直以来的支持和分享。明略和极客邦科技都相信中国技术力量，我们胸怀梦想，踏实前行，咱们纳斯达克见！',
        company: '明略数据董事长 ',
        author: '吴明辉'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7942ff94509.png?imageView2/0/',
        word: '我们处于一个终身学习的时代，很高兴看到极客邦科技的 IT 知识服务平台能伴随技术人员的成长过程。',
        company: 'TGO 会员、新浪微博副总经理 ',
        author: '杨卫华'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7adcf77993a.png?imageView2/0/',
        word: '在 IT 专业领域内，极客邦科技成为无数 IT 人的良师益友，一起学习一起成长。愿极客邦科技越走越稳，学习的道路上，一路同行。',
        company: '罗辑思维联合创始人',
        author: '快刀青衣'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a79430056280.png?imageView2/0/',
        word: '从毕业开始就一直跟随着 InfoQ 成长，看着极客邦科技从技术媒体转变成的 IT 知识服务平台，无论是技术大会还是知识服务都做到了国内优质，就拿目前 TGO 组织来说，已经是中国技术圈里面顶尖的技术组织，技术高层人士交流学习分享的第一平台，真心为霍泰稳和司巧蕾感到开心和自豪，而且随着池建强老师、郭蕾等众多大牛的加入，我坚信极客邦科技一定会成为中国高端专业的技术服务公司。',
        company: 'TGO 会员、积梦智能创始人& CEO',
        author: '谢孟军'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7ad94db23f2.png?imageView2/0/',
        word: '极客邦科技推动着技术和知识深入而广泛地传播，同时也是高端技术人才的连接器。这几年我参与极客邦科技组织的 QCon、ArchSummit、GTLC 和 TGO 活动的机会较多，我作为听众、讲师、出品人、分会长，看到了极客邦科技的进取和变化，也从分享、交流和沟通中受益良多。“独行者速、众行者远”，祝胸怀理想的极客邦科技凝聚更多的力量，促进中国技术进步。',
        company: 'TGO 会员、爱拍原创联合创始人& CTO',
        author: '邹光先'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7942ffd49f2.png?imageView2/0/',
        word: '极客邦科技 InfoQ 和我的缘分源远流长，有将近十年的时间。从阿里巴巴到途牛到现在的TutorABC，我一直保持着和极客邦科技的高度合作。我和我的同事们不仅带着团队参加了多次极客邦科技的各种会议，也参与了多次分享，受益良多。目睹了极客邦科技和中国互联网技术一起高速成长，不断推出优秀的会议和产品，影响力也越来越大，真是打心底里开心。祝极客邦科技越发成功！',
        company: 'TutorABC CTO ',
        author: '汤峥嵘'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a794301069fa.png?imageView2/0/',
        word: '极客邦科技为中国技术人的成长默默耕耘了十年，成功打造了互联网人喜爱的交流平台。近期推出的”极客时间“App 将是极客邦科技下一个精彩十年的起点，未来可期，一起加油！',
        company: 'XNode 创始人',
        author: '周炜'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7abd698ac9b.png?imageView2/0/',
        word: '从2012年 Tower 发布开始，极客邦科技一直是彩程设计的客户和合作伙伴。极客邦科技的技术交流平台能够帮助我们这样的创业小团队开拓技术视野，提升技术实力。我个人也从台下的听众，变成了极客邦科技的讲师，获益匪浅。现在的极客邦科技，从技术媒体升级到 IT 知识服务平台，祝极客邦科技生意越做越大，帮助越来越多的 IT 人成长。',
        company: 'Tower 创始人',
        author: '沈学良'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7abd685b0ad.png?imageView2/0/',
        word: '十年陪伴，十年沉淀，极客邦科技和很多 IT 人、IT 公司一起经历了互联网风起云涌的时刻。最近更是看着他们开始做各种创新和服务，尤为过瘾。祝愿极客邦科技永怀创业之心，稳健前行，成为技术人的好朋友。',
        company: '知识星球创始人 ',
        author: '吴鲁加'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7abd69016fa.png?imageView2/0/',
        word: '希望极客邦科技能够将丰富的技术服务经验和浓厚的技术社区氛围从线下转移到线上，带着为技术人服务的初心，为更多的技术人创造价值。感谢极客邦科技过去十年的陪伴，期待”极客时间“创造新的辉煌。',
        company: '无码科技联合创始人',
        author: '邱岳'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a794300c4127.png?imageView2/0/',
        word: '极客邦科技 InfoQ 从诞生之日起就成为博文视点的重要合作伙伴之一。作为知识服务平台的搭建者，极客邦科技通过会议/社区/在线教育等方式为 IT 从业人员搭建了立体化平台。期望在未来的岁月里双方通过深度合作更好地为用户服务！',
        company: '博文视点联合创始人/总经理、电子工业出版社副总编辑',
        author: '郭立'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7943de5cdbc.png?imageView2/0/',
        word: '2006年底我们开始了基调网络的创业，也是同时期开始关注到了 InfoQ，一直在关注上面的内容，是我们多年来持续获得行业技术和思想的主要途径。2014年我们推出了听云品牌，并且开始了和极客邦科技的全面合作，除了参与 QCon 和 ArchSummit 大会，还联合举办 APM 行业大会 APMCon。感谢极客邦科技对听云的帮助，两家企业都一起走过了十年的历程，希望在未来的路上还在一起，大干一票！',
        company: '听云 CTO',
        author: '陈靖华'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7abd69c4a1f.png?imageView2/0/',
        word: '随着科技对各行各业以及人们生活的影响力越来越大，作为后面重要支撑的技术力量在不管是个人择业，还是企业竞争，甚至是国家战略方面都显得越来越重要。在这期间，极客邦科技推广业界最先进的互联网技术和管理理念，并通过 TGO 建立了技术人员之间的紧密联接，尤其是新推出的极客时间 App，为广大技术从业者和行业内顶尖专家之间搭建了高效的知识传递桥梁，帮助国内的技术社区不断成长。作为 InfoQ 的读者和 TGO 会员，都从中学习到非常多的东西。也希望极客邦科技不断创新，推动中国技术力量，立足中国，走向世界！',
        company: 'TGO 会员、同盾科技技术 VP',
        author: '张新波'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7943de25371.png?imageView2/0/',
        word: '祝极客邦科技 InfoQ 越办越好，成为优质的开发者知识社区。',
        company: 'UCloud COO ',
        author: '华琨'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7bc1b29f6a6.png?imageView2/0/',
        word: '我接触极客邦科技大概有2年多时间。因近期我在”极客时间“App 上开设有一个全年专栏，所以基本上每个礼拜我都会和极客邦科技的编辑们有很深入的合作，而这其中每次合作我都被他们精湛的业务水平，努力的工作态度，高效的工作方式所打动。希望在未来的日子里我们继续一起携手前行，也祝极客邦科技越来越好。',
        company: '极客时间App 专栏作者、计算机博士',
        author: '徐飞'
      }, {
        link: 'https://www.baidu.com',
        logo: 'https://static.geekbang.org/infoq/5a7944d132b54.png?imageView2/0/',
        word: '在从事软件工程研究的十余年时间里，我和我的科研团队接触过许多国内外 IT 领域的服务机构，这其中极客邦科技团队给我留下的印象是最为专业且富有活力的。自2016年开始与极客邦科技在 DevOps 中国调研项目上开展初步合作，2017年我们的合作范围逐步扩展到联合组织软件领域顶级学术/产业会议、开发技术知识内容、搭建科研与实践沟通平台等形式。秉承服务社会、服务软件产业发展的共同目标，通过双方在学术科研和产业实践方面的优势互补，相信我们未来的合作必将更加深入而成功。在此祝愿极客邦科技，明天更加美好！',
        company: '南京大学教授、澳大利亚联邦科学院主任科学家 ',
        author: '张贺'
      }]
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

.banner
  display: flex
  justify-content: center
  align-items: center
  background: url('https://static.geekbang.org/infoq/5a99026940337.png?imageView2/0/') center center
  background-size: contain
  width: 100vw
  height: 27.6vw
  +mobile
    height: 80vw
    background: url('https://static.geekbang.org/infoq/5a990268a0070.png?imageView2/0/') center center
    background-size: cover
  .word
    display: flex
    flex-direction: column
    align-items: center
    color: #353535
    +mobile
      color: #fff
    .title
      letter-spacing: 5px
      font-size: 40px
      font-weight: 700
      margin-bottom: 15px
      +mobile
        font-size: 30px
        margin-bottom: 0px
    .subtitle
      font-size: 20px
      text-align: center
      width: 66.7vw
      +fullhd
        width: 50vw
      +mobile
        font-size: 15px
        width: 88vw
        margin: 0 auto
</style>
